import { Component, DestroyRef, OnInit } from '@angular/core';
import { ChartDataset } from 'chart.js';

import { ToArabicPipe } from '@app/shared/pipes/toArabic.pipe';
import { DashboardService } from '@app/dashboard/services/dashboard.service';
import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { BaseChartDirective } from 'ng2-charts';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '@app/core';

@Component({
  selector: 'app-dashboard-chart2',
  templateUrl: './dashboard-chart2.component.html',
  styleUrls: ['./dashboard-chart2.component.scss'],
  standalone: true,
  imports: [CommonModule, BaseChartDirective, TranslateModule]
})
export class DashboardChart2Component implements OnInit {
  constructor(
    private service: DashboardService,
    private toArabic: ToArabicPipe,
    private languageService: LanguageService,

    private destroyRef: DestroyRef
  ) {}
  loaded: boolean;
  lineChartPlugins: any[] = [];
  lineChartData: ChartDataset[] = [
    {
      data: [],
      label: '',
      yAxisID: 'A'
    }
  ];

  lineChartLabels: string[] = [];

  lineChartOptions = {};

  lineChartColors: any[] = [
    {
      borderColor: 'black',
      backgroundColor: 'rgb(93,98,181)'
    }
  ];

  lineChartLegend = false;
  lineChartType = 'bar';

  getData() {
    this.service
      .getData('today-waste-types-info')
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((data: any) => data.data),
        map((data: any) => this.refactorResponse(data))
      )
      .subscribe((response: any) => {
        this.lineChartLabels = response.map((data: any) => data['waste_type']).reverse();
        this.lineChartData[0]['data'] = response.map((data: any) => data['total_weights']).reverse();
        this.loaded = true;
      });
  }

  refactorResponse = (response: any) => {
    return response;
  };

  ngOnInit() {
    this.setOptions();
    this.getData();
  }

  changeFontSizeOnSmallScreen() {
    return window.innerWidth <= 1366 ? 10 : 12;
  }

  setOptions() {
    return (this.lineChartOptions = {
      responsive: true,

      tooltips: {
        backgroundColor: '#5D62B5',
        titleAlign: 'center',
        titleFontSize: 16,
        titleFontFamily: 'Helvetica',
        yPadding: 0,
        xPadding: 6,
        custom: function(tooltip: any) {
          //remove tooltip body
          tooltip.body = [];
        },
        callbacks: {
          // We'll edit the `title` string
          title: (tooltipItem: any) => {
            return `
${tooltipItem[0].xLabel}

  الوزن: ${this.toArabic.transform(tooltipItem[0].yLabel.toString())} طن  `;
          }
        }
      },
      //hide label dataset
      legend: {
        display: false
      },
      //change y axis to right
      scales: {
        A: {
          position: 'right'
        },
        x: {
          // width  line in x axis
          barPercentage: 0.4,
          ticks: {
            display: true,
            fontSize: this.changeFontSizeOnSmallScreen(),
            autoSkip: false
          }
        }
      },
      plugins: {
        datalabels: {
          display: false
        }
      }
    });
  }
  get isEnglish(): boolean {
    return this.languageService.isEnglish;
  }
}
